module.exports = __webpack_public_path__ + "54d0bf1eb2d9f455e53c4191ca8a4c07.pdf";